'use strict'
export const apiUrl = '//back-hitolog.n-links.biz'
export const authUrl = '//auth.n-links.biz'
export const myUrl = 'hitolog.n-links.biz'
export const appName = 'hitolog'



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 112